export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.2080e233.ttf";